import { register } from './message-router';
import { socketManager } from './network';

// Terminal Setup
const term = new Terminal({
  cursorBlink: true,
  theme: {
    background: '#000',
    foreground: '#fff'
  },
  fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
  fontSize: 14,
  scrollback: 50000,
});

const fitAddon = new FitAddon.FitAddon();
term.loadAddon(fitAddon);

const terminalEl = document.getElementById('terminal');
if (terminalEl) {
  term.open(terminalEl);
}

let currentOutputIndex = 0;
// Initial request for terminal output
socketManager.send('in', [currentOutputIndex]);

// Forward terminal input
term.onData((data: string) => {
  socketManager.send('in', [currentOutputIndex, data]);
});

// Handle 'out' messages to write to terminal
register('out', (data: [number, ...string[]]) => {
  const [index, ...output] = data;

  if (index > currentOutputIndex) {
    // Request missing output
    socketManager.send('in', [currentOutputIndex]);
    return;
  } else if (index < currentOutputIndex) {
    console.error('Received wrong terminal output. Ignoring.');
    return;
  }

  // Drop already processed output
  for (let i = currentOutputIndex - index; i < output.length; i++) {
    currentOutputIndex++;
    term.write(output[i]);
  }
});

// Handle terminal resizing
function setPTYSize(): void {
  fitAddon.fit();
  socketManager.send('size', { cols: term.cols, rows: term.rows });
}

window.addEventListener('resize', setPTYSize);

export { term, setPTYSize };
